'use strict';

import 'document-register-element';
import dispatcher from '../dispatcher';

class TextArea extends HTMLTextAreaElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
  }
  connectedCallback() {
    this.setAttribute('rows', '1');
    this.addEventListener('input', this._change, false);
    // this.addEventListener('keyup', this._change, false);

    this._lastHeight = this.scrollHeight;
  }

  _change() {
    this.style.height = 'auto';

    let height = this.scrollHeight;

    this.style.height = height + 'px';

    if (height !== this._lastHeight) {
      // TODO
      dispatcher.dispatch({
        type: 'page-size-change',
        _module: 'textarea-autosize.component'
      });

      this._lastHeight = height;
    }
  }
}

window.customElements.define('text-area', TextArea, {extends: 'textarea'});
